export const sourcePromoCodeHandler = (
  baseApplyURL,
  storageKey = 'source_code'
) => {

  if (typeof window === 'undefined') {
    return baseApplyURL;
  }
  const urlParams = new URLSearchParams(window.location.search);
  const passedPromoCode = urlParams.get('promo_code');
  const passedSourceCode = urlParams.get('source_code');

  if (!passedPromoCode && !passedSourceCode) {
    return baseApplyURL; // return as-is if no params
  }

  const sourceCode = passedSourceCode || localStorage.getItem(storageKey);

  if (passedSourceCode) {
    localStorage.setItem(storageKey, passedSourceCode);
  }

   const resolvedURL = baseApplyURL?.startsWith('/')
    ? new URL(baseApplyURL, window.location.origin + window.location.pathname)
    : new URL(baseApplyURL);

  if (sourceCode) {
    resolvedURL.searchParams.set('source_code', sourceCode);
  }

  // Return relative or absolute based on original input
  return baseApplyURL.startsWith('/')
    ? resolvedURL.pathname + resolvedURL.search
    : resolvedURL.toString();
};
